// extracted by mini-css-extract-plugin
export default {"loader":"AMEWKZYI00Kkf1OJDyzh"};